import type { Epic } from '../../../index.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import { filter, mergeMap, of } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'

export const DeleteMetadataEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.deleteMetadataItemRequest.match),
    mergeMap((action) =>
      OrderRepository.deleteMetadata({ orderId: action.payload.orderId, metadataId: action.payload.metadataId }).pipe(
        mergeMap(() =>
          of(
            order.deleteMetadataItemSuccess({
              orderId: action.payload.orderId,
              metadataId: action.payload.metadataId
            })
          )
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.deleteMetadataItemFailure({ error }))
          })
        ),
        catchError((error: Error) => {
          console.error('Error deleting metadata', error)
          return of(order.deleteMetadataItemFailure({ error }))
        })
      )
    )
  )
